import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypeDocument } from 'src/app/shared/models/typeDocument';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeDocumentModalAjoutComponent } from '../modal/typeDocument-modal-ajout/typeDocument-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { TypeDocumentModalDetailComponent } from '../modal/typeDocument-modal-detail/typeDocument-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-typeDocument',
	templateUrl: './list-typeDocument.component.html',
	styleUrls: ['./list-typeDocument.component.scss']
})
export class ListTypeDocumentComponent implements OnInit {
	typeDocument: TypeDocument[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	typeDocumentCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editTypeDocumentModalRef: BsModalRef;
	addTypeDocumentModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getTypeDocument();
		this.isAddable = true;
	}

	getTypeDocument(): void {
		this.isListingLoading = true;
		this.facade.typeDocumentService.getAllTypeDocument().subscribe({
			next: (val) => {
				this.typeDocument = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.typeDocument.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.typeDocument = [];
			}
		});
	}

	selectTypeDocument(typeDocument: TypeDocument): void {
		const link = ['/typeDocument', typeDocument.id];
		this.router.navigate(link);
	}

	importTypeDocument(event: any): void {
		this.typeDocumentCsvFile = event.target.files[0];

		this.facade.typeDocumentService
			.importTypeDocument(this.typeDocumentCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} typeDocument ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getTypeDocument();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addTypeDocumentModalRef = this.modalService.show(
			TypeDocumentModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addTypeDocumentModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeDocument();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(typeDocument: TypeDocument) {
		const initialState = {
			typeDocument: typeDocument
		};
		this.editTypeDocumentModalRef = this.modalService.show(
			TypeDocumentModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editTypeDocumentModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeDocument();
		});
	}
}
